<p-fileUpload
  accept="image/*"
  [maxFileSize]="200000"
  name="certificate-uploader"
  url="https://www.primefaces.org/cdn/api/upload.php"
  method="post"
  chooseLabel="Selecionar"
  uploadLabel="Enviar"
  [showCancelButton]="false"
  invalidFileTypeMessageDetail="deve ser .p12 ou .pfx"
  invalidFileTypeMessageSummary="Arquivo inválido, "
  invalidFileSizeMessageSummary="Arquivo é muito grande, "
  invalidFileSizeMessageDetail="deve conter até 200kb"
  [customUpload]="true"
  (uploadHandler)="onUpload()"
  (onSelect)="selectFile($event)"
  accept=".jpeg"
>
  <ng-template let-file pTemplate="file">
    <div class="file">
      <span class="pi pi-file"></span>
      <span> {{ file.name }} - {{ file.size | number }}kb </span>
    </div>
  </ng-template>
</p-fileUpload>
